import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { useDispatch } from "react-redux";
import { increment, incrementID } from "../redux/reducers";
import "../App.css";



const Login = () => {
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    let user = {
      name,
      number,
      ID: Math.floor(Math.random() * 10000000),
    };

    if (!event.isPropagationStopped()) {
      setError("You have previously registered");
    }

    dispatch(increment(user));
    dispatch(incrementID(user));

    // fetch("https://httpbin.org/post", {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(dog),
    // })
    //   .then((response) => response.json())
    //   .then(console.log);
  };

  const handleChange = ({ target }) => {
    switch (target.name) {
      case "name":
        setName(target.value);
        break;
      case "number":
        setNumber(target.value);
        break;
      default:
        return;
    }
  };

  return (
    <div class="container">
      <form onSubmit={handleSubmit} aria-invalid aria-errormessage>
        <p>Welcome</p>
        <span>{error}</span>
        <input
          placeholder="Full Name"
          type="text"
          name="name"
          value={name}
          onChange={handleChange}
          required
        />
        <br />
        <NumberFormat
          name="number"
          placeholder="Number"
          format="+998 (##) ### ## ##"
          mask="_"
          value={number}
          required
          onChange={handleChange}
        />
        <input type="submit" style={{cursor: 'pointer'}} value="submit" />
        <br />
        <a href="#">Forgot Password?</a>
      </form>

      <div class="drops">
        <div class="drop drop-1"></div>
        <div class="drop drop-2"></div>
        <div class="drop drop-3"></div>
        <div class="drop drop-4"></div>
        <div class="drop drop-5"></div>
      </div>
    </div>
  );
};

export default Login;


